import { render, staticRenderFns } from "./VaToggle.vue?vue&type=template&id=7c1bd8d6&"
import script from "./VaToggle.vue?vue&type=script&lang=js&"
export * from "./VaToggle.vue?vue&type=script&lang=js&"
import style0 from "./VaToggle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports